import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";

export const openGraphInfo = async (data: stdObject, params: stdObject) => {
  const {
    t,
    setMsg,
    setModalData,
    setModalData2,
    setWindowValues,
    logoutAction,
  } = params;
  console.log("data", data);
  setMsg("loading");
  const payloadRolInfo = {
    id: data.CODGRA,
  };
  console.log("payloadRolInfo: ", payloadRolInfo);
  const resultRolInfo: stdObject =
    data.CODGRA === ""
      ? { success: true, status: true, data }
      : await sendData({
          endPoint: "callGraph",
          payload: payloadRolInfo,
          logoutAction,
        });
  console.log("resultRolInfo: ", resultRolInfo);
  if (resultRolInfo.success) {
    setMsg("rolGraphModal");
    setModalData({
      title: data.CODROL === "" ? t("p.newGra") : resultRolInfo.info.NOMGRA,
      id: data.CODGRA,
      tabs: resultRolInfo.tabs,
    });

    setWindowValues({});
  } else {
    setModalData2({ label: resultRolInfo.error });
    setMsg("error");
  }
};
